export type ZipcodeResponse = {
  postcode: string;
  number: number;
  street: string;
  city: string;
  municipality: string;
  province: string;
  location: {
    type: string;
    coordinates: [number, number];
  };
};

export type RegistrationRequest = {
  id: number;
  email: string;
  zipcode: string;
  created_at: string;
  updated_at: string;
};

export const GenderEnum = {
  DHR: "Dhr." as const,
  MEVR: "Mevr." as const,
};

export const CountryEnum = {
  NL: "Nederland" as const,
  BE: "België" as const,
};

export type RegisterRequestBody = {
  title: "Dhr." | "Mevr.";
  first_name: string;
  insertion: string;
  last_name: string;
  phone: string;
  email: string;
  password: string;
  password_confirmation: string;
  country: "Nederland" | "België";
  zipcode: string;
  street: string;
  number: string;
  place: string;
  sync_address: boolean;
  country_invoice: "Nederland" | "België";
  zipcode_invoice: string;
  street_invoice: string;
  number_invoice: string;
  place_invoice: string;
  type_delivery: number;
  metadata: string;
  key_available: boolean;
  receive_newsletter: boolean;
  remember_me_to_order: boolean;
  payment_type: number;
  mandate_bank: object | undefined;
  pay_with_sepa: boolean;
  isInAppRequest: boolean;
};
